import { createFileRoute } from '@tanstack/react-router'
import CalculationsContainer from 'Concept/components/Concept/Sections/CalculationSection/CalculationsContainer'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/concept/$conceptId/calculations')({
    component: () => (
        <Guard notFeatures={['profitability']}>
            <CalculationsContainer />
        </Guard>
    ),
})
